<div class="h-[80px]"></div>
<div
  class="h-[80px] bg-white fixed top-0 z-50! border-b border-[#E4E9EF] flex w-full items-center justify-between pr-6"
>
  <div class="flex items-center">
    <button
      class="cursor-pointer flex items-center justify-center h-16 w-16 hover:bg-gray-100 rounded-full mx-2"
      (click)="toggleSidebar()"
    >
      <img
        src="assets/icons/hamburgerIcon.svg"
        alt="Barra lateral"
        class="h-[18px]"
      />
    </button>
    <img
      class="w-[93px]"
      src="assets/img/logo-bci-negro-transparente.png"
      alt="BCI"
    />
  </div>
  <!-- dropdown usuario -->
  <div class="relative">
    <div class="flex items-center cursor-pointer" (click)="toggleDropdown()">
      <div>
        <div
          class="w-[32px] h-[32px] text-[10px] font-medium flex items-center justify-center rounded-full mr-4 bg-[#E2EBFC] text-[#005FFF]"
        >
          {{ user.nombre.charAt(0).toLocaleUpperCase()
          }}{{ user.apellido.charAt(0).toLocaleUpperCase() }}
        </div>
      </div>
      <div class="flex flex-col justify-between">
        <div class="font-semibold text-sm text-gray-900">
          {{ user.nombre }} {{ user.apellido }}
        </div>
      </div>
    </div>
    @if (isDropdownOpen) {
    <div
      class="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50 transition-all py-1"
    >
      <div class="hover:bg-gray-100 cursor-pointer p-3" (click)="logout()">
        Cerrar sesión
      </div>
    </div>
    }
  </div>

  <!-- fin dropdown   -->
</div>
